<template>
  <div>
    <div class="refund" v-if="!dialog">
      <div class="refund-content">
        <div class="head">
          <img class="icon" :src="setIcon" />
          <div class="title">{{ current.item_long_name }}</div>
          <div class="money">¥{{ current.item_price }}</div>
          <div class="type">
            {{
              state === "refund"
                ? "申请退款"
                : state === "unsign"
                ? "申请解约"
                : ""
            }}
          </div>
        </div>
        <ul class="box">
          <li class="line">
            <div class="line-label">产品名称</div>
            <div class="line-value">{{ current.item_long_name }}</div>
          </li>
          <li class="line">
            <div class="line-label">资费说明</div>
            <div class="line-value">
              商户将每隔30天，自动从你的支付宝账户扣款{{
                current.item_price
              }}元进行续费，可随时取消，取消后不再自动续费
            </div>
          </li>
          <li class="border" />
        </ul>
        <div
          class="operate"
          @click="handleRefundOrUnsign"
          v-if="state === 'refund'"
        >
          <div class="operate-label">我要退款</div>
          <img
            class="operate-icon"
            src="https://cdn.qiumo.net.cn/allsmarketmaterial/suixintao/icon_arrow.png"
          />
        </div>
        <div
          class="operate"
          @click="handleRefundOrUnsign"
          v-if="state === 'unsign'"
        >
          <div class="operate-label">我要解约</div>
          <img
            class="operate-icon"
            src="https://cdn.qiumo.net.cn/allsmarketmaterial/suixintao/icon_arrow.png"
          />
        </div>
      </div>
    </div>
    <div class="blank" v-if="dialog">
      <div class="cont">
        <template v-if="operationalState === 'success'">
          <img
            class="icon"
            src="https://cdn.qiumo.net.cn/allsmarketmaterial/suixintao/refund_icon.png"
          />
          <div class="title">
            您已{{
              state == "refund"
                ? "退款并解约"
                : state == "unsign"
                ? "解约"
                : ""
            }}成功
          </div>
          <div class="msg" v-if="state == 'refund'">
            将于24小时内退还至原付款账户，请注意查收～
          </div>
          <div class="msg" v-if="state == 'unsign'">
            您已成功解约，希望与您再次相遇
          </div>
        </template>
        <template v-if="operationalState === 'fail'">
          <img
            class="icon"
            src="https://cdn.qiumo.net.cn/allsmarketmaterial/suixintao/refund_fail_icon.png"
          />
          <div class="title">
            {{
              state == "refund" ? "退款" : state == "unsign" ? "解约" : ""
            }}失败
          </div>
          <div class="msg">
            {{ errorMsg }}
          </div>
        </template>
        <template v-if="!operationalState">
          <img
            class="icon"
            src="https://cdn.qiumo.net.cn/allsmarketmaterial/suixintao/refund_empty_icon.png"
          />
          <div class="empty-msg">您还没有相关的订单哦</div>
        </template>
        <div class="call" v-if="!!operationalState">
          客服电话：<u @click="handleCall(setCall)">{{ setCall }}</u>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isAlipayEnvironment } from "@/utils/common";
import {
  alipayLogin,
  alipayRefund,
  alipayUnsign,
  record,
  refundable,
} from "@/api/refundsOrTerminationOfContracts";
const defaultData = { item_long_name: "", item_name: "", item_price: "" };

export default {
  data() {
    return {
      auth_code: "",
      state: "",
      appName: "",
      token: "",
      current: defaultData,
      dialog: true,
      // fail success
      operationalState: "",
      errorMsg: "",
    };
  },
  computed: {
    setIcon() {
      let img = "";
      switch (this.current.item_long_name) {
        case "随心淘会员":
          img =
            "https://cdn.qiumo.net.cn/allsmarketmaterial/suixintao/icon_sxt.png";
          break;
        case "随心淘龙年专享":
          img =
            "https://cdn.qiumo.net.cn/allsmarketmaterial/suixintao/icon_sxtlnzx.png";
          break;
        case "惠生活会员":
          img =
            "https://cdn.qiumo.net.cn/allsmarketmaterial/suixintao/icon_hshhy.png";
          break;
        case "车主会员":
          img =
            "https://cdn.qiumo.net.cn/allsmarketmaterial/suixintao/icon_car.png";
          break;
        case "随心享会员":
          img =
            "https://cdn.qiumo.net.cn/allsmarketmaterial/suixintao/icon_sxxhy.png";
          break;
        default:
          break;
      }
      return img;
    },
    setCall() {
      const call = {
        // 秋末
        huanxinxiang: "4001189599",
        // 海络
        "huanxinxiang-hailuo": "4001002501",
        // 铮行
        "huanxinxiang-zhengxing": "4001180238",
      };
      return call[this.appName];
    },
  },
  created() {
    const { auth_code = "", state = "", appName = "" } = this.$route.query;

    this.state = state;
    this.auth_code = auth_code;
    this.appName = appName;

    if (!auth_code) {
      const { origin, pathname } = location;
      const redirect_uri = encodeURIComponent(
        // "https://asa.qiumo.net.cn/pages/refund"
        origin + pathname
      );
      const url = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2021004138668016&scope=auth_base&redirect_uri=${redirect_uri}&state=${state}&appName=${appName}`;
      location.href = url;
    }

    if (!!auth_code) {
      this.login();
    }
  },
  methods: {
    async login() {
      const res = await alipayLogin({ auth_code: this.auth_code });
      this.token = res.token || "";
      if (!!this.token && this.state == "unsign") {
        this.getRecord();
      }

      if (!!this.token && this.state == "refund") {
        this.getRefundable();
      }
    },
    // 获取可解约列表
    async getRecord() {
      const res = await record(this.token, this.appName, {
        page: 1,
        data_type: "order",
        order_status: "订购中",
      });
      if (res.code == 0) {
        this.current = (res.record && res.record[0]) || defaultData;
        this.dialog = res.record.length === 0;
      }
    },
    //获取可退款列表
    async getRefundable() {
      const res = await refundable(this.token, this.appName);
      if (res.code == 0) {
        this.current = (res.record && res.record[0]) || defaultData;
        this.dialog = res.record.length === 0;
      }
    },
    // 退款
    async handleRefundOrUnsign() {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: "加载中...",
      });
      try {
        const api =
          this.state == "refund"
            ? alipayRefund(this.token, this.appName)
            : this.state == "unsign"
            ? alipayUnsign(this.token, this.appName, {
                item_name: this.current.item_name,
              })
            : "";
        const res = await api;
        this.dialog = true;

        if (res.code == 0) {
          this.operationalState = "success";
        } else {
          this.operationalState = "fail";
          this.errorMsg = res.message;
        }
      } catch (error) {
        this.dialog = true;
        this.operationalState = "fail";
        this.errorMsg =
          "目前服务器异常，请稍后重试，可直接拨打客服电话，谢谢。";
      }
      this.$toast.clear();
    },
    handleCall(phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.refund {
  background: #f5f5f5;
  padding: 30px 30px 30px 28px;
  min-height: 100vh;
  box-sizing: border-box;

  &-content {
    background: #ffffff;
    border-radius: 18px;
    height: 94vh;

    .head {
      text-align: center;
      font-weight: 400;

      .icon {
        width: 72px;
        padding: 60px 0 35px;
      }

      .title {
        font-size: 30px;
      }

      .money {
        font-size: 38px;
        padding: 14px 0 10px;
      }

      .type {
        font-size: 28px;
      }
    }

    .box {
      padding: 60px 16px 0;

      .line {
        display: flex;
        font-weight: 400;
        padding-bottom: 59px;

        &:nth-child(2) {
          padding-bottom: 30px;
        }

        &-label {
          color: #888888;
          padding-right: 84px;
          font-size: 26px;
        }

        &-value {
          font-size: 26px;
          flex: 1;
        }
      }

      .border {
        width: 630px;
        margin: 0 auto;
        height: 1px;
        background-color: #e3e3e3;
      }
    }

    .operate {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 25px 16px 0;

      &-label {
        font-size: 26px;
        color: #000000;
      }

      &-icon {
        width: 44px;
      }
    }
  }
}

.blank {
  text-align: center;
  padding-top: 121px;

  .icon {
    width: 354px;
  }

  .title {
    font-size: 34px;
    padding: 40px 0 16px;
    color: #333333;
  }

  .msg {
    font-weight: 400;
    color: #999999;
    font-size: 28px;
    padding: 0 24px;
  }

  .empty-msg {
    font-size: 28px;
    color: #999999;
    padding-top: 44px;
  }

  .call {
    // position: fixed;
    // bottom: 102px;
    // left: 0;
    // right: 0;
    line-height: 34px;
    padding-top: 6px;

    font-weight: 400;
    font-size: 28px;
    color: #999999;

    u {
      color: #333333;
    }
  }
}
</style>
